import React, { FC } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';

import { Telegram24, Stack, Typography } from 'Modules/ui3';

import { TELEGRAM_LINK } from '../../constants';


interface SocialBadgeProps {
    link: string;
    icon: (props: SvgIconProps) => JSX.Element;
    text: string;
}
const SocialBadge: FC<SocialBadgeProps> = ({ icon: Icon, link, text }) => (
    <a href={link} target='_blank' rel='noopener noreferrer'>
        <Stack
            direction='row'
            spacing={2}
            alignItems='center'
            py={1}
            pl={2}
            pr={3}
            border='1px solid'
            sx={({ palette, spacing }) => ({
                backgroundColor: palette.grayscale.shade0,
                borderColor: palette.grayscale.shade40,
                borderRadius: spacing(5),
            })}
        >
            <Icon fontSize='large' />
            <Typography variant='mediumBody2' color='grayscale.shade95'>
                {text}
            </Typography>
        </Stack>
    </a>
);

export const TelegramButton = () => (
    <SocialBadge icon={Telegram24} link={TELEGRAM_LINK} text='Telegram' />
);

